import normalizeAssignType from "./normalizeAssignType";
import normalizeDistrictName from "./normalizeDistrictName";
import normalizeStateName from "./normalizeStateName";

export default function flattenEmployeePayload(payload) {
  const out = [];
  for (const row of payload || []) {
    const name = row?.employee_name || row?.name || "—";
    const position = row?.position || "—";
    const assignType = normalizeAssignType(row?.assign_type);
    const reportTo = row?.report_to || null;

    const areas = Array.isArray(row?.areas) ? row.areas : [];
    if (areas.length) {
      for (const a of areas) {
        out.push({
          name,
          position,
          assignType,
          reportTo,
          state: normalizeStateName(a?.state),
          district: normalizeDistrictName(a?.district || a?.area || ""),
          shops: Number(a?.shops || 0),
          lat: a?.lat,
          lng: a?.lng,
        });
      }
      continue;
    }

    out.push({
      name,
      position,
      assignType,
      reportTo,
      state: normalizeStateName(row?.state),
      district: normalizeDistrictName(row?.district || row?.area || ""),
      shops: Number(row?.shops || row?.total_shops || 0),
      lat: row?.lat,
      lng: row?.lng,
    });
  }
  return out;
}